MultiStepForm[5] = {
  bank_account_number: false,
}

const isValidIBANNumber = (input) => {
  const ibanString = String(input).toUpperCase()
  const iban = ibanString.replace(/[^A-Z0-9]/g, "")
  const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/)

  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
    return false
  }

  const append = code[3] + code[1] + code[2]
  const digits = append.replace(/[A-Z]/g, function (letter) {
    return letter.charCodeAt(0) - 55
  })

  return mod97(digits)
}

const mod97 = (string) => {
  let checksum = string.slice(0, 2)
  let fragment = ""

  for (let offset = 2; offset < string.length; offset += 7) {
    fragment = String(checksum) + string.substring(offset, offset + 7)
    checksum = parseInt(fragment, 10) % 97
  }

  return checksum
}

const validateBankAccountNumber = (value) => {
  return isValidIBANNumber(value) === 1
}

jQuery(document).ready(function ($) {
  $("body").on("keyup", "#form-input-step-5 input", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    let success = false

    if (name == "bank_account_number") {
      success = validateBankAccountNumber(value)
    }

    if (success) {
      showSuccess(5, name)
    } else {
      showError(5, name, field, value)
    }
  })

  $("body").on("click", "#submit-button-step-5", function (event) {
    event.preventDefault()
    submitForm(5)
  })

  $("body").on("click", "#previous-button-step-5", function (event) {
    event.preventDefault()
    showPreviousForm(4)
  })

  $("body").on("click", "#mobile-previous-button-step-5", function (event) {
    event.preventDefault()
    showPreviousForm(4)
  })

  $("body").on("click", "#sidebar-step-4", function (event) {
    event.preventDefault()
    showPreviousForm(4, "sidebar")
  })
})
